module.exports = __webpack_public_path__ + "static/media/naslovnicaBJN1.7faa4681.png";